import { connect } from 'react-redux';
import { isPredictedRoute } from '@Pages/RetroSynthesis/ProjectRoute/selectors';
import { getProjectsInfoMap } from '@Pages/RetroSynthesis/RsBreadcrumbs/selector';
import { getProjectsRoutesDataResponseList } from '@Pages/RetroSynthesis/ProjectRoutes/selectors';
import RouteOverviewTreePopupContainer from './RouteOverviewTreePopupContainerBase';

const mapStateToProps = (state) => ({
  isPredictedRoute: isPredictedRoute(state),
  projectsInfo: getProjectsInfoMap(state),
  routes: getProjectsRoutesDataResponseList(state),
});

export default connect(mapStateToProps, null)(RouteOverviewTreePopupContainer);
